// Heuristic used by the readonly form: a click on an interactive-looking
// descendant (input/button/textarea/select) switches the page into edit mode.
export const shouldEnterEditModeOnClick = (e: any, readonly: boolean): boolean => {
  if (
    !readonly ||
    e.target.parentElement.id === 'configuration-page-form' ||
    e.target.parentElement.role === 'tabpanel' ||
    e.target.type === 'checkbox'
  ) {
    return false;
  }

  const tagName = e.target.tagName.toLowerCase();
  const isInput = ['input', 'button', 'textarea'].includes(tagName);
  const isSelect = e.target.querySelectorAll('[class*="select"]').length > 0;
  const hasButtons = e.target.querySelectorAll('button').length > 0;

  return isInput || isSelect || hasButtons;
};
